/**
 * External Dependencies
 */
import 'jquery';

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse' // https://alpinejs.dev/plugins/collapse
import setScrollBarWidth from 'set-scrollbar-width'; // https://github.com/LucidNinja/set-scrollbar-width

import './contact-us-modal';
import './program-modal';
import "./self-assessment-modal";
import "./notification-bar";

import './forms/form-handler';

window.Alpine = Alpine

Alpine.prefix("data-x-")
Alpine.plugin(collapse)
Alpine.start()

/**
 * Run the application when the DOM is ready.
 */
document.addEventListener( "DOMContentLoaded", function(){
    setScrollBarWidth();
}, false );
